import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";
import { useApi } from "@shopexperts/shared";
import type { AdminExpertManagerStats } from "@shopexperts/legacy-api";

const EMPTY_STATUSES = {
  application: 0,
  draft: 0,
  published: 0,
  unpublished: 0,
  banned: 0,
} as const;

const EMPTY_STATS: AdminExpertManagerStats = {
  all_experts: { total: 0, statuses: { ...EMPTY_STATUSES } },
  types: {
    freelancer: { total: 0, statuses: { ...EMPTY_STATUSES } },
    agency: { total: 0, statuses: { ...EMPTY_STATUSES } },
    app_service_provider: { total: 0, statuses: { ...EMPTY_STATUSES } },
  },
};

export function useExpertManagerStats() {
  const api = useApi();

  const { data, isLoading, error } = useQuery({
    queryKey: ["admin", "experts", "stats"],
    queryFn: () => api.admin.expertManager.getStats(),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  const stats = computed<AdminExpertManagerStats>(() => data.value ?? EMPTY_STATS);

  return { stats, isLoading, error };
}
